import React, { Component } from 'react';
import "react-datetime/css/react-datetime.css";
import Comm from '../comm/comm';
import Context from '../context/context';
import Translation from '../translation/translation';

export default class InvoiceByNum extends Component {

    constructor(props) {
        super(props);
        this.FindInvoice = this.FindInvoice.bind(this);
        this.state = { invoiceNo: null };
    }

    FindInvoice() {
        var sid = Context.GetContext().Sid;

        var data = Comm.CallServerFunction("invoices/get_invoice_new_by_nom", { session: sid, nom: this.state.invoiceNo });
        if (data.result === null)
            this.setState({ notfound: true });
        else {
            this.setState({ notfound: false });
            this.props.ShowInvoice(data.result);

        }

    }


    render() {
        return (

            <div className="row">
                <div className="col-md-10">
                    <input type="text" className="form-control" value={this.state.invoiceNo} onChange={(e) => this.setState({ invoiceNo: e.target.value })} placeholder={Translation.Trans("invoiceno")}></input>
                    {
                        this.state.notfound ?
                            <div className="alert alert-danger">{Translation.Trans("notfound")}</div>
                            : null
                    }

                </div>
                <div className="col-md-2">
                    {
                        this.state.invoiceNo ?
                            <button className="btn btn-info" onClick={this.FindInvoice}>{Translation.Trans("show")}</button>
                            : null
                    }
                </div>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/controls/invoicebynum.js